<template>
    <div class="row">
        <div class="sm-12">
            <p>
                <strong>Unidade: {{ unidade.Descricao }}</strong>
            </p>
            <div class="responsive-table">
                <table class="default-table">
                    <thead>
                        <tr>
                            <th align="left" width="200">CONTRATO PAR</th>
                            <th width="120">DATA</th>
                            <th align="left">PROPRIETÁRIO</th>
                            <th align="left" width="250">SIT. JURIDICO</th>
                            <th width="250">N. PROCESSO</th>
                            <th width="300" align="left">ADVOGADO</th>
                        </tr>
                    </thead>
                        <Item v-for="item in unidade.Itens" :key="item.id" :item="item"></Item>
                    
                </table>

            </div>
        </div>
    </div>
</template>
<script>
import Item from './item.vue';
export default {
    props: ["unidade"],
    components: {
        Item
    }
};
</script>